// * Bootstrap libraries
import "./main/_bootstrap";

// * Any other global site-wide JavaScript should be placed here.
